
import { mapGetters } from 'vuex'

import api from '~/api/' // server
import ListDetailPageLinkTable from '~/components/Common/ListView/ListDetailPageLinkTable'
import ListRegiContent from '~/components/Common/ListView/ListRegiContent'
import ListRegiContentStatus from '~/components/Common/ListView/ListRegiContentStatus'
import ListPagination from '~/components/Common/ListView/ListPagination'
import ListDirectBanking from '~/components/Common/ListView/ListDirectBanking'
import DetailListUnderView from '~/components/Common/ListView/DetailListUnderView'
import DetailListUnderViewWithAnswer from '~/components/Common/ListView/DetailListUnderViewWithAnswer'
import DetailListUnderDirectBanking from '~/components/Common/ListView/DetailListUnderDirectBanking'
import SearchPeriod from '~/components/Common/UI/Search/SearchPeriod'

export default {
    name: 'ListContainer',
    components: {
        SearchPeriod,
        ListDetailPageLinkTable,
        ListPagination,
        ListDirectBanking,
        ListRegiContent,
        ListRegiContentStatus,
        DetailListUnderView,
        DetailListUnderViewWithAnswer,
        DetailListUnderDirectBanking,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        searchPlaceholder: {
            type: String,
            default: '내용을 입력해주세요',
        },
        newsType: {
            type: String,
            default: null,
        },
        detailPath: {
            type: String,
            default: 'Notice',
        },
        detailPage: {
            type: Boolean,
            default: false,
        },
        isRegiContent: {
            type: Boolean,
            default: false,
        },
        isRegiContentStatus: {
            type: Boolean,
            default: false,
        },
        isRegiContentStatusWithAnswer: {
            type: Boolean,
            default: false,
        },
        isDirectBanking: {
            type: Boolean,
            default: false,
        },
        updateObserver: {
            type: Boolean,
            default: false,
        },
        subtitleName: {
            type: String,
            default: '제목',
        },
        subcontentName: {
            type: String,
            default: '내용',
        },
    },
    data() {
        return {
            pagingInfo: {
                listItem: {
                    items: [],
                },
                curIdx: 0,
                nextKey: [],
                rePosition: 0,
                prevPosition: -1,
                isLast: false,
            },
            isShowDetail: false,
            detailParams: {},
            prevParams: {}, // 이전 parameter와 같으면 request 보내지 않고, isShowDetail=false 주기 위한 data
        }
    },
    computed: {
        ...mapGetters('search', ['getSearch']),

        paging() {
            if (!this.pagingInfo.listItem) return

            const start = this.pagingInfo.curIdx * 5
            const end = (this.pagingInfo.curIdx + 1) * 5

            const items = this.pagingInfo.listItem.items.slice(start, end)

            return items
        },

        pageLength() {
            if (!this.pagingInfo.listItem) return 5
            return Object.keys(this.pagingInfo.listItem.items).length
        },
    },

    watch: {
        getSearch() {
            this.getBoardList()
        },
        updateObserver() {
            const nextKey = this.getNextKey()
            this.getBoardList(nextKey)
        },
    },

    mounted() {
        this.getBoardList()
    },

    methods: {
        async getBoardList(key) {
            this.pagingInfo.listItem = null

            const params = {
                newsType: this.newsType,
                ...this.getSearch,
            }

            if (key) {
                params.nextKey = key
            }

            this.pagingInfo.listItem = (await api.getBoardList(params)).data

            try {
                // 받아온 key값 list에 index에 맞게 할당
                const nextKey = this.pagingInfo.listItem.nextKey
                this.keyAssign(nextKey)
            } catch {}
        },
        getCurIdx(idx) {
            this.pagingInfo.curIdx = idx
        },
        getPosition(position) {
            // 다음이나, 이전 버튼 누르는 경우
            // 페이지네이션 index 초기화
            const isPrev = this.isUpOrDown(position)
            this.prevPosition = position // 검증 후, 현재 위치를 이전 위치로 재할당

            // > 눌렀다가 < 눌러서 돌아오면 마지막 항목보이도록 처리
            this.pagingInfo.curIdx = isPrev ? 4 : 0

            // 처음으로 다음 버튼을 누를 경우 2가 되므로, 1 빼서 index를 1으로 맞춰준다. (0은 첫페이지므로)
            this.pagingInfo.rePosition = position - 1

            const nextKey = this.getNextKey()

            this.getBoardList(nextKey)
        },
        keyAssign(nextKey) {
            // 받아온 키값 페이지 순서대로 nextKey[]에 저장
            this.pagingInfo.nextKey[this.pagingInfo.rePosition] = nextKey

            // nextKey가 없으면, > 아이콘 비활성화
            if (nextKey === null) {
                this.pagingInfo.isLast = true
            } else {
                this.pagingInfo.isLast = false
            }
        },
        getDetailParams(params) {
            // detail에 필요한 params만 받아서 overlay 부분에 재전달 후, detail에서 request 보냄
            if (params.id === this.prevParams.id) {
                this.isShowDetail = false
                this.prevParams = {} // 닫은 후, 다시 열 수 있도록 초기화,
            } else {
                // 이전 parameter와 다르다면,
                this.prevParams = params

                this.detailParams = params
                this.isShowDetail = true
            }
        },
        backToList() {
            // 닫기 버튼 클릭 시
            this.isShowDetail = false
            this.prevParams = {} // 닫은 후, 다시 열 수 있도록 초기화,
        },
        isUpOrDown(currPosition) {
            if (this.prevPosition - currPosition > 0) return true
            else return false
            // > 클릭한 경우, false (다음페이지 클릭)
            // < 클릭한 경우, true (이전페이지 클릭)
        },
        getNextKey() {
            // 현재 위치의 key 값 가져오기
            // 다음 찾아올 key값은 이전에 받아온 key 값이 되므로, 재정의한 위치에서 -1 해서 가져온다.
            const nextKey = this.pagingInfo.nextKey[
                this.pagingInfo.rePosition - 1
            ]
            return nextKey
        },
        catchSummit() {
            // 무통장의 경우, summit 성공 후, 아래 디테일 페이지 닫기
            this.isShowDetail = false
            this.prevParams = {} // 닫은 후, 다시 열 수 있도록 초기화,
            // 리스트 새로고침
            this.getBoardList()
        },
    },
}
